import React from 'react';

const tableHeader = (props) => {
  const csvButton = <button className="btn" onClick={(e) => props.downloadAsCSV()}>Sækja gögn á CSV-sniði</button>
  return (
    <caption>{"Heildarfjöldi niðurstaðna: " + props.totalRows + " línur á " + props.totalPages + " síðum. "}{csvButton}</caption>
  )
}

export default tableHeader;



// WEBPACK FOOTER //
// ./src/Components/Table/TableCaption/TableCaption.js